import $ from "jquery";

var GPPYFAQ = {
    init: function() {
        $('.faqelement').click(GPPYFAQ.toggle);
    },

    toggle: function(e) {
        var el = $(e.target).closest(".faqelement");
        if (el.hasClass("expanded"))
            el.removeClass("expanded").addClass("collapsed");
        else {
            el.addClass("expanded").removeClass("collapsed");
        }
    }

}

$('document').ready(GPPYFAQ.init);

